(function () {

  console.log("Bundle Selector JS loaded");

  function initBundleSelector() {

    console.log("Initializing Bundle Selector");

    if (!window.bundleConfig) {
      console.error("Bundle Selector: bundleConfig not found");
      return;
    }

    var root = document.querySelector(
      "[data-bundle-selector]"
    );

    if (!root) {
      console.error(
        "Bundle Selector: [data-bundle-selector] not found"
      );
      return;
    }

    var container = root.querySelector(
      "[data-bs-container]"
    );

    var oneTimeButton = root.querySelector(
      "[data-bs-onetime]"
    );

    if (!container) {
      console.error(
        "Bundle Selector: container not found"
      );
      return;
    }

    var config = window.bundleConfig;

    var bundles = config.bundles || [];

    if (!bundles.length) {
      console.error(
        "Bundle Selector: no bundles found"
      );
      return;
    }

    var selected = bundles.find(function (bundle) {

      return Number(bundle.id) ===
        Number(config.settings.defaultBundle);

    });

    if (!selected) {
      selected = bundles[0];
    }


    /*
     * MONEY
     */

    function money(value) {

      return (
        config.settings.currency +
        Number(value).toFixed(2)
      );

    }


    /*
     * RENDER
     */


function render() {

  console.log("Rendering bundles:", bundles);

  var html = "";

  bundles.forEach(function (bundle) {

    var active =
      Number(bundle.id) === Number(selected.id);

    html += `

      <article
        class="
          bs-option
          ${active ? "bs-option--active" : ""}
          ${bundle.featured ? "bs-option--featured" : ""}
        "
        data-bs-id="${bundle.id}"
      >

        ${
          bundle.popular
            ? `
              <div class="bs-popular">
                ${bundle.popular}
              </div>
            `
            : ""
        }


        <div class="bs-option-inner">


        


          <!-- HEADING -->

          <div class="bs-heading">

            <h3 class="bs-title">
              ${bundle.title}
            </h3>

            <p class="bs-subtitle">
              ${bundle.subtitle}
            </p>

          </div>


          <!-- PRODUCT IMAGE -->

          <div class="bs-product-visual">

            <img
              src="${bundle.image}"
              alt="${bundle.imageAlt || ""}"
            >

            ${
              bundle.freeLabel
                ? `
                  <span class="bs-free-label">
                    ${bundle.freeLabel}
                  </span>
                `
                : ""
            }

          </div>


          <!-- VIAL COUNT -->

          ${
            bundle.vialCount
              ? `
                <div class="bs-vial-count">
                  ${bundle.vialCount}
                </div>
              `
              : ""
          }


          <!-- PRICE PER VIAL -->

          ${
            bundle.pricePerVial
              ? `
                <div class="bs-price-per-vial">
                  <strong>${bundle.pricePerVial}</strong>
                  <span>/ vial</span>
                </div>
              `
              : ""
          }


          <!-- TOTAL -->

          <div class="bs-total-price">

            <span>
              Total
            </span>

            <strong>
              ${money(bundle.price)}
            </strong>

            ${
              bundle.comparePrice
                ? `
                  <del>
                    ${money(bundle.comparePrice)}
                  </del>
                `
                : ""
            }

          </div>


          <!-- INSIDE LINK -->

          <div class="bs-inside" style="display:none">

            <span class="bs-info-icon">
              ⓘ
            </span>

            <span>
              ${config.settings.insideText}
            </span>

          </div>


          <!-- FREQUENCY -->

          <div class="bs-frequency">
            ${bundle.frequency}
          </div>


          ${
            bundle.proTip &&
            bundle.proTip.enabled
              ? `
                <div class="bs-tip">

                  <span class="bs-tip-icon">
                    !
                  </span>

                  <strong>
                    ${bundle.proTip.label}
                  </strong>

                  <span>
                    ${bundle.proTip.text}
                  </span>

                </div>
              `
              : ""
          }


          <!-- BENEFITS -->

        <div class="bs-benefits">

  ${
    (bundle.benefits || [])
      .map(function (benefit) {

        return `
          <span>
            <i>✓</i>
            ${benefit}
          </span>
        `;

      })
      .join("")
  }

</div>


          <!-- PERKS -->

          <div class="bs-perks">

            ${
              (bundle.perks || [])
                .map(function (perk) {

                  return `
                    <span class="bs-perk">

                      ${
                        perk.icon
                          ? `
                            <img
                              class="bs-perk-icon"
                              src="${perk.icon}"
                              alt=""
                              width="18"
                              height="18"
                            >
                          `
                          : ""
                      }

                      <span class="bs-perk-text">
                        ${perk.text}
                      </span>

                    </span>
                  `;

                })
                .join("")
            }

          </div>


          <!-- ORDER BUTTON -->

          <button
            type="button"
            class="bs-order"
            data-bs-order="${bundle.id}"
          >

            ${bundle.orderButton.text}

            ${
              bundle.discount
                ? `
                  <span>
                    ${bundle.discount}
                  </span>
                `
                : ""
            }

          </button>


        </div>

      </article>

    `;

  });


  container.innerHTML = html;

  bindEvents();

  updateVariant();

  updateOneTimeButton();

}

    /*
     * EVENTS
     */

    function bindEvents() {

      root.querySelectorAll(
        "[data-bs-id]"
      ).forEach(function (card) {


        card.addEventListener(
          "click",
          function (event) {


            var orderButton =
              event.target.closest(
                "[data-bs-order]"
              );


            /*
             * ORDER NOW
             */

            if (orderButton) {

              var orderId =
                Number(
                  orderButton.dataset.bsOrder
                );


              selected =
                bundles.find(function (bundle) {

                  return Number(bundle.id) ===
                    orderId;

                });


              updateVariant();

              submitSubscription();

              return;

            }


            /*
             * SELECT BUNDLE
             */

            var id =
              Number(card.dataset.bsId);


            selected =
              bundles.find(function (bundle) {

                return Number(bundle.id) ===
                  id;

              });


            render();

          }
        );

      });

    }


    /*
     * UPDATE SHOPIFY PRODUCT FORM
     */

    function updateVariant() {

      var form =
        document.querySelector(
          'form[action*="/cart/add"]'
        );


      if (!form) {

        console.warn(
          "Bundle Selector: Shopify product form not found"
        );

        return;

      }


      var variantInput =
        form.querySelector(
          'input[name="id"]'
        );


      if (!variantInput) {

        console.warn(
          "Bundle Selector: variant input not found"
        );

        return;

      }


      variantInput.value =
        selected.variantId;


      variantInput.dispatchEvent(
        new Event(
          "change",
          {
            bubbles: true
          }
        )
      );


      /*
       * SELLING PLAN
       */

      var sellingPlan =
        form.querySelector(
          'input[name="selling_plan"]'
        );


      if (!sellingPlan) {

        sellingPlan =
          document.createElement(
            "input"
          );

        sellingPlan.type =
          "hidden";

        sellingPlan.name =
          "selling_plan";

        form.appendChild(
          sellingPlan
        );

      }


      sellingPlan.value =
        selected.sellingPlan;


      console.log(
        "Selected variant:",
        selected.variantId
      );

      console.log(
        "Selected selling plan:",
        selected.sellingPlan
      );

    }


    /*
     * ONE TIME PURCHASE BUTTON
     */

    function updateOneTimeButton() {

      if (!oneTimeButton) return;


      if (
        !config.settings.oneTimePurchase.enabled
      ) {

        oneTimeButton.style.display =
          "none";

        return;

      }


      oneTimeButton.textContent =
        config.settings.oneTimePurchase.text +
        config.settings.oneTimePurchase.separator +
        money(selected.price);

    }


    /*
     * SUBSCRIPTION ATC
     */

 function submitSubscription() {

  var form = document.querySelector(
    'form[action*="/cart/add"]'
  );

  if (!form) {
    console.error(
      "Bundle Selector: product form not found"
    );
    return;
  }

  updateVariant();

  setTimeout(function () {

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }

      return response.json();

    })
    .then(function () {

      // Item has been added to cart
      // Redirect directly to Shopify checkout
      window.location.href = '/checkout';

    })
    .catch(function (error) {

      console.error(
        'Bundle Selector: checkout error',
        error
      );

    });

  }, 100);

}

    /*
     * ONE TIME PURCHASE
     */

async function oneTimePurchase() {
  if (!oneTimeButton) return;

  oneTimeButton.disabled = true;

  const originalText = oneTimeButton.textContent;
  oneTimeButton.textContent = "ADDING...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(selected.variantId),
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error("Cart request failed");
    }

    // Product has been added successfully
    window.location.href = "/checkout";

  } catch (error) {
    console.error("Bundle Selector:", error);

    oneTimeButton.disabled = false;
    oneTimeButton.textContent = originalText;
  }
}

    if (oneTimeButton) {

      oneTimeButton.addEventListener(
        "click",
        oneTimePurchase
      );

    }


    /*
     * INITIAL RENDER
     */

    render();

  }


  /*
   * DOM READY
   */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initBundleSelector
    );

  } else {

    initBundleSelector();

  }

})();